import { useState } from "react";
import Tooltip from "./Tooltip";

const MedicationSummary = ({ medication, summary }) => {
    const [hovered, setHovered] = useState(null);
    const [rect, setRect] = useState(null);

    const totalDays = summary.length;
    const completedDays = summary.filter((d) => d.schedule_completed).length;
    const compliance = Math.round((completedDays / totalDays) * 100);

    const startDate = summary.length > 0 ? summary[0].date : null;
    const endDate = summary.length > 0 ? summary[summary.length - 1].date : null;

    return (
        <div className="bg-white p-4 mb-4 rounded-lg shadow-sm border">
            {/* Header */}
            <div className="flex justify-between items-center mb-2">
                <div>
                    <h3 className="font-semibold text-gray-800 text-base">
                        {medication.medicineName}{" "}
                        <span className="text-sm text-gray-500">(Dosage : {medication.dosage}/day)</span>
                    </h3>
                    {medication.description && (
                        <p className="text-sm text-gray-500">{medication.description}</p>
                    )}
                    <p className="text-sm text-gray-400">
                        {startDate && `From: ${startDate}`}{" "}
                        {endDate && `→ To: ${endDate}`}
                    </p>
                </div>
                <div className="text-right">
                    <span className="text-sm font-semibold text-gray-700">{compliance}%</span>
                    <p className="text-[10px] text-gray-500">
                        {completedDays}/{totalDays} days
                    </p>
                </div>
            </div>

            {/* Progress bar */}
            <div className="w-full bg-gray-200 h-2 rounded-full mb-3">
                <div
                    className="bg-green-500 h-2 rounded-full"
                    style={{ width: `${compliance}%` }}
                />
            </div>

            {/* GitHub style grid */}
            <div className="overflow-x-auto">
                <div className="flex space-x-1 py-2">
                    {summary.map((day, idx) => (
                        <div
                            key={idx}
                            className={`min-w-3 h-3 rounded-sm cursor-pointer ${day.schedule_completed ? "bg-green-500" : "bg-red-400"
                                }`}
                            onMouseEnter={(e) => {
                                setHovered(day);
                                setRect(e.currentTarget.getBoundingClientRect());
                            }}
                            onMouseLeave={() => setHovered(null)}
                        />
                    ))}
                </div>
            </div>

            {/* Tooltip */}
            {hovered && (
                <Tooltip targetRect={rect}>
                    {hovered.date} – {hovered.schedule_completed ? "Completed" : "Missed"}
                </Tooltip>
            )}
        </div>
    );
};

export default MedicationSummary;
